<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <!-- Breadcrumb Navigation (Matching reference page) -->
      <nav
        class="d-flex align-items-center flex-wrap gap-2 mb-3"
        aria-label="breadcrumb"
      >
        <a
          class="back-link d-flex align-items-center justify-content-center rounded-circle text-decoration-none"
          routerLink="/applicationConfiguration"
          [title]="'COMMON.BACK' | translate"
          (click)="goBack()"
        >
          <mat-icon class="text-primary">arrow_back</mat-icon>
        </a>

        <div class="d-flex align-items-center">
          <mat-icon class="me-3" color="primary">email</mat-icon>
          <p class="fw-semibold mb-0" style="font-size: 20px">
            {{
              "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Email_Templates" | translate
            }}
          </p>
        </div>

        <span class="text-secondary mx-2">/</span>
        <span class="text-secondary">{{
          "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Email_Manage" | translate
        }}</span>
      </nav>
    </div>

    <div class="col-lg-12">
      <div class="card shadow-sm border-0 rounded-3">
        <!-- Card Header with Title and Add Button (Matching reference page style) -->
        <div class="card-header border-0 p-3">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap gap-3"
          >
            <div>
              <h5 class="mb-1 d-flex align-items-center text-muted">
                <span>{{
                  "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Email_Manage" | translate
                }}</span>
              </h5>
              <p class="text-muted small mb-0">
                {{
                  "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Create_and_manage_email_templates_for_your_application"
                    | translate
                }}
              </p>
            </div>

            <!-- Add Button with Material Design (Matching reference) -->
            <button
              type="button"
              mat-stroked-button
              color="primary"
              data-bs-toggle="modal"
              data-bs-target="#smtpEmailtemplateModal"
              (click)="resetsForm()"
              class="d-flex align-items-center"
            >
              <mat-icon class="me-2">add</mat-icon>
              {{ "BUTTONS.ADD" | translate }}
            </button>
          </div>
        </div>

        <!-- Alerts (Matching reference page) -->
        <div class="px-3">
          <app-ncs-alert
            *ngIf="form['message']"
            [message]="form['message']"
            [type]="form['error'] ? 'danger' : 'success'"
          >
          </app-ncs-alert>
        </div>

        <!-- Table Section -->
        <div class="card-body p-3">
          <div class="table-container">
            <div class="table-responsive table-scrollable">
              <table class="table table-bordered table-sticky-header">
                <thead>
                  <tr>
                    <th class="text-center">
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.S.No"
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.Template_Code"
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.Subject"
                          | translate
                      }}
                    </th>
                    <th style="max-width: 200px">
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.Body"
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.Type"
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.HTML"
                          | translate
                      }}
                    </th>
                    <th>
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.Status"
                          | translate
                      }}
                    </th>
                    <th class="text-center">
                      {{
                        "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Table.Actions"
                          | translate
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let template of templates; let i = index">
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>{{ template.templateCode }}</td>
                    <td>{{ template.subject }}</td>

                    <!-- Truncate Long Text -->
                    <td
                      class="text-truncate"
                      style="max-width: 200px"
                      title="{{ template.messageBody }}"
                    >
                      {{ template.messageBody }}
                    </td>

                    <td>{{ template.type }}</td>
                    <td>{{ template.html === "1" ? "Yes" : "No" }}</td>
                    <td>{{ template.status }}</td>

                    <!-- Action Buttons -->
                    <td class="text-center">
                      <button
                        mat-stroked-button
                        class="icon-center icon-width me-2"
                        color="primary"
                        (click)="editTemplate(template)"
                      >
                        <mat-icon class="icon-compact">edit</mat-icon>
                      </button>

                      <button
                        mat-stroked-button
                        class="icon-center icon-width"
                        color="warn"
                        (click)="deleteTemplate(template.id)"
                      >
                        <mat-icon class="icon-compact">delete</mat-icon>
                      </button>
                    </td>
                  </tr>

                  <!-- Empty State -->
                  <tr *ngIf="templates.length === 0">
                    <td colspan="9" class="text-center text-muted">
                      No templates found
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Template Modal-->
<div
  class="modal fade"
  id="smtpEmailtemplateModal"
  tabindex="-1"
  aria-labelledby="smtpModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center" id="smtpModalLabel">
          <mat-icon color="primary">email</mat-icon>
          <span class="ms-2">{{
            "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Email_Template" | translate
          }}</span>
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        ></button>
      </div>

      <!-- Alerts -->
      <app-ncs-alert
        *ngIf="form['message']"
        [message]="form['message']"
        [type]="form['error'] ? 'danger' : 'success'"
        class="m-3"
      >
      </app-ncs-alert>

      <!-- Modal Body with Form -->
      <form #emailTemplateForm="ngForm">
        <div class="modal-body p-4">
          <div class="row g-4">
            <!-- Subject & Template Code - Two columns -->
            <div class="col-md-6">
              <label
                for="subject"
                class="form-label fw-medium text-secondary mb-2"
              >
                <span class="ms-2"></span
                >{{
                  "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Subject" | translate
                }}
                <span class="text-danger">*</span>
              </label>
              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  id="subject"
                  name="subject"
                  type="text"
                  placeholder="{{
                    'EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Subject_Place'
                      | translate
                  }}"
                  [(ngModel)]="form.data.subject"
                  #subject="ngModel"
                  required
                />
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <label
                for="templateCode"
                class="form-label fw-medium text-secondary mb-2"
              >
                {{
                  "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Template_Code"
                    | translate
                }}
                <span class="text-danger">*</span>
              </label>

              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  id="templateCode"
                  name="templateCode"
                  type="text"
                  placeholder="{{
                    'EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Template_Code_Place'
                      | translate
                  }}"
                  [(ngModel)]="form.data.templateCode"
                  #templateCode="ngModel"
                  required
                />
              </mat-form-field>
            </div>

            <!-- Message Body - Full Width -->
            <div class="col-12">
              <label
                for="messageBody"
                class="form-label fw-medium text-secondary mb-2"
              >
                {{
                  "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Message_Body"
                    | translate
                }}
                <span class="text-danger">*</span>
              </label>

              <mat-form-field appearance="outline" class="w-100">
                <textarea
                  matInput
                  id="messageBody"
                  name="messageBody"
                  placeholder="{{
                    'EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Message_Body_Place'
                      | translate
                  }}"
                  [(ngModel)]="form.data.messageBody"
                  #messageBody="ngModel"
                  rows="4"
                  required
                ></textarea>
              </mat-form-field>
            </div>

            <!-- HTML, Type, Status - Three columns -->
            <div class="col-md-4">
              <label
                for="html"
                class="form-label fw-medium text-secondary mb-2"
              >
                {{
                  "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.HTML_Formate"
                    | translate
                }}
              </label>

              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  id="html"
                  name="html"
                  [(ngModel)]="form.data.html"
                  placeholder="{{
                    'EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.HTML_Format_Place'
                      | translate
                  }}"
                >
                  <mat-option value="1">Yes</mat-option>
                  <mat-option value="0">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <label
                for="type"
                class="form-label fw-medium text-secondary mb-2"
              >
                {{ "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Type" | translate }}
                <span class="text-danger">*</span>
              </label>
              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  id="type"
                  name="type"
                  [(ngModel)]="form.data.type"
                  #type="ngModel"
                  placeholder="{{
                    'EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Type_Select'
                      | translate
                  }}"
                  required
                >
                  <mat-option value="email">Email</mat-option>
                  <mat-option value="sms">SMS</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-md-4">
              <label
                for="status"
                class="form-label fw-medium text-secondary mb-2"
              >
                {{
                  "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Status" | translate
                }}
                <span class="text-danger">*</span>
              </label>
              <mat-form-field appearance="outline" class="w-100">
                <mat-select
                  id="status"
                  name="status"
                  [(ngModel)]="form.data.status"
                  #status="ngModel"
                  placeholder="{{
                    'EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Select_Status'
                      | translate
                  }}"
                  required
                >
                  <mat-option value="active">Active</mat-option>
                  <mat-option value="inactive">Inactive</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button
            type="button"
            mat-flat-button
            color="primary"
            class="me-2"
            [disabled]="!emailTemplateForm.valid"
            (click)="saveTemplateConfig()"
          >
            <mat-icon>save</mat-icon>
            {{ "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Save" | translate }}
          </button>
          <button
            type="button"
            mat-stroked-button
            color="warn"
            data-bs-dismiss="modal"
            (click)="closeModal()"
          >
            <mat-icon>close</mat-icon>
            {{ "EMAIL_CONFIGURATION.EMAIL_TEMPLATE.Form.Close" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
